import { Grid } from '@mui/material';
import { FileTypeEnum } from 'remote/global';
import {
  useOperatorsBankAccountQuery,
  useOperatorsFilesQuery,
  useOperatorsQuery,
} from 'api/queries/operators';
import AccountCompanyImageForm from 'components/forms/AccountFactory/AccountCompanyImageForm';
import AccountBankDetailsForm from 'components/forms/AccountFactory/AccountBankDetailsForm';
import AccountCompanyDetailsForm from 'components/forms/AccountFactory/AccountCompanyDetailsForm';

function AccountImageView() {
  const { data: files, isSuccess } = useOperatorsFilesQuery();

  if (!isSuccess) return null;

  const operatorLogoFiles = files.filter((f) => f.fileType === FileTypeEnum.OPERATOR_LOGO);
  return (
    <AccountCompanyImageForm // Only spread defaultValues if the attachments is present
      // Because we want the component to stay in 'undefined' for correct error handling
      {...(operatorLogoFiles.length > 0 && { defaultValues: { attachments: operatorLogoFiles } })}
    />
  );
}

function AccountBankDetailsView() {
  const { data: bankAccount, isSuccess } = useOperatorsBankAccountQuery();

  if (!isSuccess) return null;

  return <AccountBankDetailsForm defaultValues={{ iban: bankAccount?.iban }} />;
}

function SettingsCompanyDetailsView() {
  const { data: operatorDetails, isSuccess } = useOperatorsQuery();

  if (!isSuccess) return null;

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} md='auto'>
        <AccountCompanyDetailsForm defaultValues={operatorDetails} />
      </Grid>
      <Grid item xs={12} md='auto'>
        <AccountImageView />
      </Grid>
      <Grid item xs={12} md='auto'>
        <AccountBankDetailsView />
      </Grid>
    </Grid>
  );
}

export default SettingsCompanyDetailsView;
